/*
 Copyright (c) 2025 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/* global WebAssembly, URL, fetch, atob */

import { setWasmExports, setInitError, resetWasmExports } from "./zlib-streams.js";

let initializedModule = false;

async function initModule(wasmURI, { baseURI }) {
	if (!initializedModule) {
		try {
			await instantiateModule(wasmURI, baseURI);
			initializedModule = true;
		} catch (error) {
			setInitError(error);
			throw error;
		}
	}
}

async function instantiateModule(wasmURI, baseURI) {
	let arrayBuffer, uri;
	try {
		try {
			uri = new URL(wasmURI, baseURI);
		} catch {
			// ignored
		}
		const response = await fetch(uri);
		arrayBuffer = await response.arrayBuffer();
	} catch (error) {
		if (wasmURI.startsWith("data:application/wasm;base64,")) {
			arrayBuffer = arrayBufferFromDataURI(wasmURI);
		} else {
			throw error;
		}
	}
	const wasmInstance = await WebAssembly.instantiate(arrayBuffer);
	setWasmExports(wasmInstance.instance.exports);
}

function resetWasmModule() {
	initializedModule = false;
	resetWasmExports();
}

function arrayBufferFromDataURI(dataURI) {
	const base64 = dataURI.split(",")[1];
	const binary = atob(base64);
	const len = binary.length;
	const bytes = new Uint8Array(len);
	for (let i = 0; i < len; ++i) {
		bytes[i] = binary.charCodeAt(i);
	}
	return bytes.buffer;
}

export {
	CompressionStreamZlib,
	DecompressionStreamZlib
} from "./zlib-streams.js";
export {
	initModule,
	resetWasmModule
};